export var ResourceType;
(function (ResourceType) {
    ResourceType["PEOPLE"] = "people";
    ResourceType["EQUIPMENT"] = "equipment";
    ResourceType["MATERIALS"] = "materials";
    ResourceType["SUBCONTRACT"] = "subcontract";
    ResourceType["OTHER"] = "other";
})(ResourceType || (ResourceType = {}));
export var RelationshipLagCalendar;
(function (RelationshipLagCalendar) {
    RelationshipLagCalendar["PREDECESSOR"] = "PREDECESSOR";
    RelationshipLagCalendar["SUCCESSOR"] = "SUCCESSOR";
    RelationshipLagCalendar["PROJECT_DEFAULT"] = "PROJECT_DEFAULT";
    RelationshipLagCalendar["TWENTY_FOUR_HOUR"] = "TWENTY_FOUR_HOUR";
})(RelationshipLagCalendar || (RelationshipLagCalendar = {}));
export var CcTaskType;
(function (CcTaskType) {
    CcTaskType["TASK"] = "task";
    CcTaskType["RFI_CONTAINER"] = "rfis-container";
    CcTaskType["RFI"] = "rfi";
    CcTaskType["SUBMITTAL_CONTAINER"] = "submittals-container";
    CcTaskType["SUBMITTAL"] = "submittal";
    CcTaskType["WORKFLOW_STATE"] = "ws";
    CcTaskType["MILESTONE"] = "milestone";
})(CcTaskType || (CcTaskType = {}));
export var WorkingType;
(function (WorkingType) {
    WorkingType["working"] = "working";
    WorkingType["nonWorking"] = "non_working";
})(WorkingType || (WorkingType = {}));
